<p-dialog [header]="'termsAcceptanceDialog.galleryTerms' | transloco" [(visible)]="showDialog" [modal]="true" [closable]="false"
  [style]="{'max-width': '900px', 'width': '90vw'}" (onHide)="onDialogClose()" class="p-dialog-modern">

  <div class="container-fluid p-4">
    <!-- Help Text for User Guidance -->
    <div class="alert alert-info mb-5 rounded-lg shadow-sm">
      <div class="d-flex align-items-center">
        <i class="pi pi-info-circle text-primary me-2"></i>
        <p class="mb-0 text-dark">
          {{ 'termsAcceptanceDialog.helpText' | transloco }}
        </p>
      </div>
    </div>

    <!-- Gallery Info Alert -->
    @if (galleryDetails) {
      <div class="bg-white mb-5 rounded-lg shadow-sm p-3">
        <div class="d-flex align-items-center">
          <img [src]="galleryDetails.GalleryImgUrl || 'assets/images/default-gallery.png'"
            class="rounded-circle border"
            style="width: 56px; height: 56px; object-fit: cover;" [alt]="'termsAcceptanceDialog.galleryImage' | transloco" />
            <div class="ms-3">
              <h5 class="mb-1 fw-bold text-dark">{{ galleryDetails.BusinessName || galleryDetails.Name }}</h5>
              <p class="mb-0 text-muted small">{{ 'termsAcceptanceDialog.reviewAndAccept' | transloco }}</p>
            </div>
          </div>
        </div>
      }

      <!-- Terms Sections -->
      <div class="terms-sections mb-4">
        <!-- Empty Message -->
        @if (!galleryDetails || (!galleryDetails?.GalleryTermsHistroyDTO?.PaymentTerms && !galleryDetails?.GalleryTermsHistroyDTO?.ReturnPolicy && !galleryDetails?.GalleryTermsHistroyDTO?.TermsConditions && !galleryDetails?.GalleryTermsHistroyDTO?.GalleryDocumentDTOs?.length)) {
          <div class="bg-white rounded-lg shadow-sm p-4 text-center"
            >
            <i class="pi pi-info-circle text-muted mb-3 d-block" style="font-size: 2rem;"></i>
            <p class="mb-0 text-muted">{{ 'termsAcceptanceDialog.noTermsAvailable' | transloco }}</p>
          </div>
        }

        <!-- Payment Terms Section -->
        @if (galleryDetails?.GalleryTermsHistroyDTO?.PaymentTerms) {
          <div class="bg-white rounded-lg shadow-sm overflow-hidden">
            <div class="bg-light px-3 py-2">
              <h6 class="mb-0 fw-semibold text-dark"><i class="pi pi-credit-card me-2 text-primary"></i>{{ 'termsAcceptanceDialog.paymentTerms' | transloco }}</h6>
            </div>
            <div class="p-4">
              <div class="text-dark" [innerHTML]="galleryDetails?.GalleryTermsHistroyDTO?.PaymentTerms || ''"></div>
              <!-- Payment Terms Documents -->
              @if (getDocumentsBySection(1)?.length) {
                <div class="mt-4">
                  <div class="row g-3">
                    @for (doc of getDocumentsBySection(1); track doc) {
                      <div class="col-12 col-md-6">
                        <div class="bg-light rounded-lg p-3 border">
                          <div class="d-flex justify-content-between mb-2">
                            <div class="flex-grow-1">
                              <h6 class="mb-1 fw-semibold text-dark">
                                @if (doc.DocumentUrl?.includes('.pdf')) {
                                  <i class="pi pi-file"></i>
                                }
                                @if (doc.DocumentUrl?.includes('.docx')) {
                                  <i class="pi pi-file"></i>
                                }
                                {{ doc.DocumentName | slice:0:25 }}{{ doc.DocumentName.length > 25 ? '...' : '' }}
                              </h6>
                              @if (doc.UploadedAt) {
                                <small class="text-muted">
                                  {{ 'termsAcceptanceDialog.uploaded' | transloco }} {{ doc.UploadedAt | date:'mediumDate' }}
                                </small>
                              }
                            </div>
                          </div>
                          <button pButton type="button" class="p-button-outlined w-100"
                            [label]="'termsAcceptanceDialog.viewDocument' | transloco" (click)="viewDocument(doc.DocumentUrl)"
                            [title]="'termsAcceptanceDialog.viewTitle' | transloco: { name: doc.DocumentName }">
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <!-- Return/Refund Policy Section -->
        @if (galleryDetails?.GalleryTermsHistroyDTO?.ReturnPolicy) {
          <div class="bg-white rounded-lg shadow-sm overflow-hidden">
            <div class="bg-light px-3 py-2">
              <h6 class="mb-0 fw-semibold text-dark"><i class="pi pi-undo me-2 text-warning"></i>{{ 'termsAcceptanceDialog.returnRefundPolicy' | transloco }}</h6>
            </div>
            <div class="p-4">
              <div class="text-dark" [innerHTML]="galleryDetails?.GalleryTermsHistroyDTO?.ReturnPolicy || ''"></div>
              <!-- Return Policy Documents -->
              @if (getDocumentsBySection(2)?.length) {
                <div class="mt-4">
                  <div class="row g-3">
                    @for (doc of getDocumentsBySection(2); track doc) {
                      <div class="col-12 col-md-6">
                        <div class="bg-light rounded-lg p-3 border">
                          <div class="d-flex justify-content-between mb-2">
                            <div class="flex-grow-1">
                              <h6 class="mb-1 fw-semibold text-dark">
                                @if (doc.DocumentUrl?.includes('.pdf')) {
                                  <i class="pi pi-file"></i>
                                }
                                @if (doc.DocumentUrl?.includes('.docx')) {
                                  <i class="pi pi-file"></i>
                                }
                                {{ doc.DocumentName | slice:0:25 }}{{ doc.DocumentName.length > 25 ? '...' : '' }}
                              </h6>
                              @if (doc.UploadedAt) {
                                <small class="text-muted">
                                  {{ 'termsAcceptanceDialog.uploaded' | transloco }} {{ doc.UploadedAt | date:'mediumDate' }}
                                </small>
                              }
                            </div>
                          </div>
                          <button pButton type="button" class="p-button-outlined w-100"
                            [label]="'termsAcceptanceDialog.viewDocument' | transloco" (click)="viewDocument(doc.DocumentUrl)"
                          [title]="'termsAcceptanceDialog.viewTitle' | transloco: { name: doc.DocumentName }"></button>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <!-- Terms & Conditions Section -->
        @if (galleryDetails?.GalleryTermsHistroyDTO?.TermsConditions) {
          <div class="bg-white rounded-lg shadow-sm overflow-hidden">
            <div class="bg-light px-3 py-2">
              <h6 class="mb-0 fw-semibold text-dark"><i class="pi pi-file me-2 text-success"></i>{{ 'termsAcceptanceDialog.termsConditions' | transloco }}</h6>
            </div>
            <div class="p-4">
              <div class="text-dark" [innerHTML]="galleryDetails?.GalleryTermsHistroyDTO?.TermsConditions || ''"></div>
              <!-- Terms & Conditions Documents -->
              @if (getDocumentsBySection(3)?.length) {
                <div class="mt-4">
                  <div class="row g-3">
                    @for (doc of getDocumentsBySection(3); track doc) {
                      <div class="col-12 col-md-6">
                        <div class="bg-light rounded-lg p-3 border">
                          <div class="d-flex justify-content-between mb-2">
                            <div class="flex-grow-1">
                              <h6 class="mb-1 fw-semibold text-dark">
                                @if (doc.DocumentUrl?.includes('.pdf')) {
                                  <i class="pi pi-file"></i>
                                }
                                @if (doc.DocumentUrl?.includes('.docx')) {
                                  <i class="pi pi-file"></i>
                                }
                                {{ doc.DocumentName | slice:0:25 }}{{ doc.DocumentName.length > 25 ? '...' : '' }}
                              </h6>
                              @if (doc.UploadedAt) {
                                <small class="text-muted">
                                  {{ 'termsAcceptanceDialog.uploaded' | transloco }} {{ doc.UploadedAt | date:'mediumDate' }}
                                </small>
                              }
                            </div>
                          </div>
                          <button pButton type="button" class="p-button-outlined w-100"
                            [label]="'termsAcceptanceDialog.viewDocument' | transloco" (click)="viewDocument(doc.DocumentUrl)"
                          [title]="'termsAcceptanceDialog.viewTitle' | transloco: { name: doc.DocumentName }"></button>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>

    <!-- Footer with Agreement Checkbox -->
    <ng-template pTemplate="footer">
      <div class="p-4 bg-light border-top rounded-bottom">
        <div class="d-flex align-items-center mb-3">
          <input class="form-check-input" type="checkbox" id="agreeTerms"
            [(ngModel)]="isTermsAccepted">
            <label class="form-check-label fw-semibold text-dark ms-2" for="agreeTerms">
              {{ 'termsAcceptanceDialog.iAgreeLabel' | transloco }}
            </label>
          </div>
          <div class="d-flex justify-content-end gap-2">
            <button pButton type="button" class="p-button-outlined"
            [label]="'termsAcceptanceDialog.cancel' | transloco" (click)="onCancel()"></button>
            <button pButton type="button" class="p-button-primary"
            [label]="'termsAcceptanceDialog.acceptAndSendArtwork' | transloco" [disabled]="!isTermsAccepted" (click)="onAcceptTerms()"></button>
          </div>
        </div>
      </ng-template>
    </p-dialog>
